<template>
<div>
<flash-message class="myCustomClass"></flash-message>
<v-dialog v-model="dialogadd" max-width="500px">
		<template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark class="mb-2">Add Note</v-btn>
		</template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Note</span>
                    </v-card-title>

                    <div v-if="validationErrors">
                        <ul class="alert alert-danger">
                            <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                        </ul>
                    </div>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex>
                                    <v-textarea v-model="addedItem.note" auto-grow label="Note:"></v-textarea>
                                </v-flex>
			 	<v-flex>
                                    <v-checkbox v-model="addedItem.is_private" label="Private"></v-checkbox>
                                </v-flex>
                
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1"  @click="closeadd">Cancel</v-btn>
                        <v-btn color="blue darken-1"  @click="store">Save</v-btn>
                    </v-card-actions>
                </v-card>
</v-dialog>
<v-spacer></v-spacer>
<v-dialog v-model="dialogedit" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Edit Note</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
               			<v-flex>
                                    <v-textarea v-model="editedItem.note" auto-grow label="Note:"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" @click="closeedit">Cancel</v-btn>
                        <v-btn color="blue darken-1" @click="update">Save</v-btn>
                    </v-card-actions>
                </v-card>
</v-dialog>
<v-spacer></v-spacer>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>
<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field  clearable v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>   

<v-data-table v-if="isAdmin == 'true'" :footer-props="{'items-per-page-options': [100,200,1000]}"  :headers="filteredheaders"
:loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination" sort-by="created_at"  multi-sort>

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<template slot="headers" slot-scope="props">
<tr>
<th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
</tr>
<tr class="grey lighten-3">

<th v-for="header in props.headers" :key="header.text">

<div v-if="filters.hasOwnProperty(header.value)">

<v-select hide-details small multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]">
</v-select>

</div>

</th>

</tr>
</template>

<template slot="items" slot-scope="props">
<td class="table-fit" v-for="header in filteredheaders"><span style="font-size: 100%;" v-bind:class="BackgroundColor(props.item, header.value)">{{ props.item[header.value] }}</span></td>
</template>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

<template v-slot:item.email="{ item }">
          <a :href="'mailto:' + item.netid + '@uis.edu'">{{ `${item.netid}@uis.edu`  }}</a>
</template>

<template v-slot:item.id="{ item }">
          <a :href="'/tentativecourses/indexbyuin/' + item.student_uin +'/' + item.term_cd"><v-icon title="View student info">visibility</v-icon></a>
</template>

<template v-slot:item.edit="{ item }">
     <v-btn icon class="mx-0" @click="editItem(item)">
     <v-icon color="teal">edit</v-icon>
     </v-btn>
</template>

<template v-slot:item.email="{ item }">
     <v-btn icon class="mx-0" @click="emailItem(item)">
     <v-icon color="blue">email</v-icon>
     </v-btn>
</template>

</v-data-table>

</v-card>

</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
	data () {
		return {
app_name: process.env.MIX_APP_NAME,
search: '',
fill:[],
filteredheaders: [],
editedIndex: -1,
filteredheaderarray: [],
headerarray:[],
progress_bar_loading: true,
validationErrors: '',
dialogadd: false,
dialogedit: false,
addedItem: {
                id: '',
                note: '',
		student_uin: '',
		is_private: ''
            },
defaultItem: {
                id: '',
                note: '',
		student_uin: '',
		is_private: ''
            },
editedItem: {
                id: '',
                note: '',
		student_uin: '',
		is_private: ''
            },
		rowsPerPageItems: [10,50,100,2000],
		missing_header: { text: 'Registered for Fall', value: 'has_registered', sortable: true, },
		headers: [
		{ text: 'Actions', value: 'id', sortable: false, },
                { text: 'Note', value: 'note', sortable: true, },
                { text: 'Created by', value: 'created_by_name', sortable: true, },
                { text: 'Created at', value: 'created_at', sortable: true, },
                { text: 'Edit', value: 'edit', sortable: false, },
                { text: 'Email Note', value: 'email', sortable: false, },
		],
		
		filters: {
			uin:[],
			note:[]
		},

		selected:[],
		pagination: {

		},

		Results:[],
	}
	},
	     created () {
		     this.initialize()
	     },
props: {
studentid: {
             type: String,
                   required: true,
                              },
ctitle: {
             type: String,
                   required: true,
                              },
isAdmin: {
      type: String,
      required: true,
    }
       },
       computed:{
		filteredResults() {
		return this.Results.filter(d => {
			return Object.keys(this.filters).every(f => {
				return this.filters[f].length < 1 || this.filters[f].includes(d[f])
			})
		})
		}
       },

methods:
       {
		columnValueList(val) {
			
			return this.Results.map(d => d[val])
		},

	       mounted() {
	       },
	       initialize()
	       {
		       this.fetchApp()
			this.filteredheaders = this.headers;
	       },
	       async fetchApp(){
		       await axios.get('/api/v1/notesapi?uin=' + this.studentid)
			       .then((response) => {
					       this.Results = (response.data);
					       this.progress_bar_loading = false;
					       })
		       .catch(error => {});

         },
	 store(student_uin){
            axios.post('/api/v1/notesapi', {
                    student_uin: this.studentid,
                    note: this.addedItem.note,
                    is_private: this.addedItem.is_private
                })
                .then(response => {
                    this.Results.push(response.data);
                  
                    this.closeadd()
                })
                .catch((error) => {
                    // Error
                  
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (error.response.status == 422) {
                            this.validationErrors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                      
                    } else {
                        // Something happened in setting up the request that triggered an Error
                
                    }
                })
	 },
	 closeadd(){
	this.validationErrors = ''
            this.dialogadd = false
            setTimeout(() => {
                this.addedItem = Object.assign({}, this.defaultItem)
                this.addedIndex = -1
            }, 300)	
	 },
	editItem(item) {
            this.editedIndex = this.Results.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogedit = true
        },
	emailItem(item){
	var cnfm = confirm('Are you sure you want to email this note to the student?')
	if (cnfm == true) {
	axios.post('/api/v1/notesapi/email', {
		id: item.id
	})
	.then(response => {
		if(response.status === 200)
			{
		
			}
	})
	.catch((error) => {
                    // Error
                   
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (error.response.status == 422) {
                            this.validationErrors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                      
                    } else {
                        // Something happened in setting up the request that triggered an Error
                       
                    }
                })
	}
	},
	closeedit(){
	this.validationErrors = ''
        this.dialogedit = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            }, 300)
	},
	update(){
         if (this.editedIndex > -1) {
                axios.put('/api/v1/notesapi/' + this.editedItem.id, {
                        note: this.editedItem.note,
                    })
                    .then(response => {
			if(response.status === 200)
			{
                       
			}
                    })
                    .catch((error) => {
                        // Error
                       
                        if (error.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (error.response.status == 422) {
                                this.validationErrors = error.response.data.errors;
                            }
                        } else if (error.request) {
                            // The request was made but no response was received
                            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                            // http.ClientRequest in node.js
                          
                        } else {
                            // Something happened in setting up the request that triggered an Error
                           
                        }
                    })
			Object.assign(this.Results[this.editedIndex], this.editedItem)
            } 
            this.closeedit()	
	},
          customFilter(items, search, filter) {
                    search = search.toString().toLowerCase();
                    this.fill = items.filter(i => (
                                            Object.keys(i).some(j => filter(i[j], search))
                                            ))
                           
                    return this.fill;
            },
        reset()
                     {
                     this.fetchApp();
                     },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));

      //ADDED has_registered because it was a computed value (template v-slot) that would not go in the download
      this.filteredheaderarray.push(this.missing_header.value)

      this.headers.forEach(element => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

     
      first_record_json_keys  = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
     
      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
    
      for (var k =0;k<local_delete.length;k++)
      {
        for(var i=0;i<all_headers_not.length;i++)
        {
                var key = all_headers_not[i];
                delete local_delete[k][key];
        }
      }
     
      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                        var date = new Date();
      XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                        this.filteredheaderarray = [];
      this.headerarray = [];
    },

BackgroundColor: function(equipment, key) {
    var result = '';

if(key == 'status')
	{
		if(equipment.status.includes('Overdue'))
		{
		result = 'badge p-2 h-3 font-weight-light badge-warning'	
		}
    else if (equipment.status.includes('Due'))
    {
      result = 'badge p-2 h-3 font-weight-light badge-info'
    }
        else 
    {
      result = 'badge p-2 font-weight-light badge-success'
    }
}

    return result;
  }

 }
}
</script>
